import React, { SVGProps } from 'react';
import { SvgContainer } from '@/components/icon/SvgContainer';

export const PillIcon = (props: SVGProps<SVGSVGElement>) => (
  <SvgContainer strokeWidth={1.6} {...props}>
    <rect
      x="2.5"
      y="8.5"
      width="19"
      height="7"
      rx="3.5"
      transform="rotate(-45 12 12)"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.55 9.55l4.9 4.9" />
  </SvgContainer>
);
